export default __webpack_public_path__ + "static/selfapp-footer-mobile-302de31582b764e58719c8fb31a392d4.jpg";